module.exports = __webpack_public_path__ + "img/7.22010944.png";